import { Pipe, PipeTransform } from '@angular/core';
import { FormatDurationPipe } from 'src/app/pipes/format-duration.pipe';
import { ScenarioService } from 'src/app/services/scenario.service';

@Pipe({
  name: 'formatDataTableData',
})
export class FormatDataTableDataPipe implements PipeTransform {
  constructor(public formatDurationPipe: FormatDurationPipe) {}

  transform(value: any, col: any): unknown {
    let returnValue = value;
    if (col.format) {
      if (col.format == 'keyVal') {
        returnValue = '<div>';

        for (const [key, val] of Object.entries(value)) {
          returnValue += key + ':<b>' + val + '</b><br>';
        }

        returnValue += '</div>';
      }
      if (col.format == 'var') {
        const variables = JSON.parse(value);
        variables.forEach((_var: any) => {
          if (_var.name == col.varName) {
            returnValue = _var.value;
          }
        });
      }
      if (col.format == 'userVar') {
        returnValue = value[col.userVar];
      }
      if (col.format == 'duration') {
        returnValue = this.formatDurationPipe.transform(value, 's', 'hh:mm:ss');
      }
    }

    return returnValue;
  }
}
